import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { getAccounting } from './accounting.selectors';

export const getAccountingCustomers = createSelector(getAccounting, ({ customers }) => customers);

export const getAccountingCustomerById = memoizeOne(id =>
  createSelector(getAccountingCustomers, customers =>
    customers?.find(item => id && item.id === id),
  ),
);
